import ContactSensor from './ContactSensor';

export default class Window extends ContactSensor {}
